export const getCmsTemplateSpectrum = (color: string) => {
  switch (color) {
    case 'catskill-white':
    case 'desert-storm':
      return 'light';

    case 'black':
    case 'blue-gradient':
    case 'cyan-gradient':
    case 'lime-gradient':
    case 'grey':
    case 'blue':
    case 'green':
    case 'orange':
    case 'cloudy':
    case 'blue-900':
    case 'primary-900':
      return 'dark';

    case 'primary-200':
    case 'primary-100':
      return 'gray';

    case 'primary-50':
    case 'beige-500':
    case 'grey-100':
    case 'white':
      return 'primary';
  }

  return 'light';
};

export function setCmsTemplateClasses(color: string, component: string, hideStripes?: boolean) {
  const spectrum = getCmsTemplateSpectrum(color);
  const {
    public: { brand },
  } = useRuntimeConfig();
  return [
    brand === 'dahl' && !hideStripes
      ? `cms-template__${component}--stripes cms-template--stripes cms-template--${spectrum}--stripes`
      : '',
    `cms-template--${spectrum} cms-template--${color}`,
  ];
}

export const setCmsTemplateClassesCampaignBadges = (color: string) => {
  return [`cms-template--${getCmsTemplateSpectrum(color)} cms-template--badge--${color}`];
};

export const CMS_FIELD_QUERY = {
  STORE_PAGE:
    'fields.storeId,fields.name,fields.address,fields.phone,fields.phoneNumbers,fields.email,fields.location,fields.openingHoursMondays,fields.openingHoursTuesdays,fields.openingHoursWednesdays,fields.openingHoursThursdays,fields.openingHoursFridays,fields.openingHoursSaturdays,fields.openingHoursSundays',
};
